module.exports = __webpack_public_path__ + "static/media/urbangoothem02.1063cfa0.webp";